import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Leaderboard from "./pages/Leaderboard";
import Dashboard from "./pages/Dashboard";
import ResultPage from "./pages/ResultPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import VsIndex from "./pages/VsIndex";
import VsPage from "./pages/VsPage";
import CategoryPage from "./pages/CategoryPage";
import UseCasePage from "./pages/UseCasePage";
import BillingSuccess from "./pages/BillingSuccess";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/r/:id" element={<ResultPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/vs" element={<VsIndex />} />
        <Route path="/vs/:slug" element={<VsPage />} />
        <Route path="/best-ai-face-analysis-tool" element={<CategoryPage variant="best" />} />
        <Route path="/best-looksmaxxing-app" element={<CategoryPage variant="looksmax" />} />
        <Route path="/use-cases/:slug" element={<UseCasePage />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
